export const NOTIFICATIONS_QUERY_KEYS = {
  base: ['notifications'],
  id: (id: number) => [...NOTIFICATIONS_QUERY_KEYS.base, id],
  filters: (filters: AnyObject) => [...NOTIFICATIONS_QUERY_KEYS.base, { page: filters }],
};
